import React, { useState } from "react";
import Select from "../Select";
import { RxCaretRight, RxChevronDown } from "react-icons/rx";

const purchasesStatusOptions = [
  { value: "pending", text: "Pendiente" },
  //        { value: "approved", label: "Aprobado" },
  //      { value: "rejected", label: "Rechazado" },
  { value: "canceled", text: "Cancelado" },
  //    { value: "shipped", label: "Enviado" },
  { value: "delivered", text: "Entregado" },
];

const PurchaseCard = ({ info, handleChangePurchaseStatus }) => {
  const [status, setStatus] = useState(info.status);
  const [closed, setClosed] = useState(true);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
    handleChangePurchaseStatus(e.target.value, info.id);
  };

  return (
    <div className="flex flex-col max-w-[950px] w-full p-6 bg-white border-[1px] border-accent-green rounded-lg gap-2 h-fit">
      <div className="flex flex-wrap flex-row justify-between gap-2 w-full">
        <div className="flex flex-col color text-dark-green text-sm font-poppins">
          <span className="text-wrap">
            <b className="text-wrap">Id de transacción:</b> {info.transactionId}
          </span>
          <span className="text-wrap ">
            <b className="text-wrap">Número de orden:</b> {info.orderNumber}
          </span>
        </div>
        <div className="flex flex-row items-center gap-2">
          <Select
            options={purchasesStatusOptions}
            setValue={handleStatusChange}
            initialValue={status}
            //onChange={(e) => handleChangePurchaseStatus(e, info.id)}
          />
          <button
            className="bg-dark-green text-base  h-fit hover:cursor-pointer rounded-full p-1 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
            onClick={() => setClosed(!closed)}
          >
            {closed ? (
              <RxCaretRight className="w-5 h-5" />
            ) : (
              <RxChevronDown className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>

      {!closed && (
        <h3 className="font-poppins text-lg font-bold ">Productos:</h3>
      )}
      {!closed && (
        <div className="flex flex-wrap  gap-2 text-dark-green w-full">
          {info.products.map((product, i) => {
            return (
              <div
                className="flex flex-col  gap-1 font-poppins w-fit border-[1px] rounded-md p-2 "
                key={i}
              >
                <img
                  src={`${process.env.REACT_APP_SERVER}${product.mainImage.url}`}
                  alt=""
                  className="w-[100px] h-[100px] rounded-md"
                />
                <span className="text-dark-green text-base font-bold">
                  {product.subClass.name}
                </span>
                <span className="text-dark-green text-base">
                  Código: {product.code}
                </span>
                <span className="text-base font-bold">
                  {" "}
                  Precio: S/{product.salePrice}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {!closed && (
        <div className="w-full flex md:flex-row flex-col p-2 gap-2">
          <div className="md:w-[50%] w-full flex flex-col gap-2 font-poppins ">
            <h3 className="text-lg font-bold">Datos de envío</h3>
            <ul>
              <li>
                <b>Distrito:</b> {info.district}
              </li>
              <li className="break-words">
                <b>Dirección:</b> {info.address}
              </li>
              <li>
                <b>Código postal:</b> {info.zipCode}
              </li>
              <li>
                <b className="break-words">Referencia:</b>{" "}
                <p>{info.addressReference}</p>
              </li>
              <li>
                <b>Fecha de entrega:</b>{" "}
                {new Date(info.shippingDate).toLocaleDateString()}
              </li>
              <li className="break-words">
                <b>Instrucciones de entrega:</b>{" "}
                <p>{info.deliveryInstructions}</p>
              </li>
            </ul>
          </div>
          <div className="md:w-[50%] w-full flex flex-col gap-2 font-poppins">
            <h3 className="text-lg font-bold">Datos del pedido</h3>
            <ul>
              <li>
                <b>Fecha de compra:</b>{" "}
                {new Date(info.createdAt).toLocaleDateString()}{" "}
              </li>
              <li>
                <b>Cliente:</b> {info.clientUser.name}{" "}
                {info.clientUser?.lastName}
              </li>
              <li className="break-words">
                <b>Correo:</b> {info.clientUser.email}
              </li>
              <li>
                <b>Teléfono:</b> {info.clientUser.phone}
              </li>
              <li>--------------------------</li>
              <li className="text-light-purple-600">
                <b>Subtotal:</b> s/
                {info.products.reduce(
                  (acc, product) => acc + product.salePrice,
                  0
                )}
              </li>
              <li className="text-light-purple-600">
                <b>Costo de envío:</b> s/{info.deliveryPrice}
              </li>
              <li className="text-dark-purple">
                <b>Monto total:</b> s/{info.amount}
              </li>
            </ul>
          </div>
        </div>
      )}

      {closed && (
        <div>
          <div className="flex flex-row gap-4">
            <span className="text-light-purple-600">
              <b>Subtotal:</b> s/
              {info.products.reduce(
                (acc, product) => acc + product.salePrice,
                0
              )}
            </span>
            <span className="text-light-purple-600">
              <b>Costo de envío:</b> s/{info.deliveryPrice}
            </span>
            <span className="text-dark-purple">
              <b>Monto total:</b> s/{info.amount}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseCard;
